import { FC, ReactNode } from 'react';

import { LucideIcon } from 'lucide-react';

import {
    StatusNoticeTone,
    STATUS_MESSAGE_ROW_CLASS,
} from './orderStatusNoticeTone';

interface Props {
    tone: StatusNoticeTone;
    icon: LucideIcon;
    message: ReactNode;
    action?: ReactNode;
}

export const OrderStatusNotice: FC<Props> = ({
    tone,
    icon: Icon,
    message,
    action,
}) => {
    return (
        <div className={`mt-3 rounded-xl border p-3 ${tone.container}`}>
            <div className="flex flex-col gap-2 text-sm sm:flex-row sm:items-center sm:justify-between">
                <div className={STATUS_MESSAGE_ROW_CLASS}>
                    <Icon className={tone.text} />
                    <span className={`font-medium ${tone.text}`}>
                        {message}
                    </span>
                </div>
                {action && action}
            </div>
        </div>
    );
};
